import "./style.css";
import { useSelector } from "react-redux";
import React, { useReducer } from "react";
import { useTranslation } from "react-i18next";
import { BLUE_EIGHT, WHITE } from "../../../theme";
import { FormButton } from "../../../components/form";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { SearchInput } from "../../../components/form/searchInput";

export const TableHeader = ({ handleAdd, SearchValue }) => {
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );
  const handleChange = (prop) => (event) => {
    SearchValue(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  const { t } = useTranslation();
  const { role } = useSelector((state) => state.user);
  return (
    <div className="table-header user-management-th">
      <div className="left-column">
        <SearchInput
          disabled={role === "readOnly" ? true : false}
          hideLabel={true}
          error={searchError}
          value={search}
          onChange={handleChange}
          label={t("text_search_by_user_name")}
          name="search"
          height={40}
        />
      </div>

      <div>
        <FormButton
          startIcon={<AddCircleIcon />}
          height={40}
          width={"10vw"}
          borderTopRightRadius={15}
          borderTopLeftRadius={15}
          borderBottomLeftRadius={15}
          borderBottomRightRadius={15}
          style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700" }}
          borderColor={BLUE_EIGHT}
          titleColor={BLUE_EIGHT}
          hoverTitleColor={WHITE}
          hoverBorderColor={BLUE_EIGHT}
          backgroundColor={WHITE}
          hoverBackgroundColor={BLUE_EIGHT}
          title={t("text_add_user")}
          onClickHandler={handleAdd}
        />
      </div>
    </div>
  );
};
